module.exports = __webpack_public_path__ + "static/media/audience.b3af61f9.png";